import { createSlice } from "@reduxjs/toolkit";
import { Profile } from "../../profiles/models/Profile";
import { Permission } from "../models/Permission";

const ProfilesInitialState: {
	profiles: Profile[];
	permissions: Permission[] | null;
} = {
	profiles: [],
	permissions: null,
};

export const ProfilesReducer = createSlice({
	name: "__",
	initialState: ProfilesInitialState,
	reducers: {
		setProfiles(state, { payload }) {
			state.profiles = payload;
		},
		setPermissions(state, { payload }) {
			state.permissions = payload;
		},
	},
});
